// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_sgu0a fl","tabSwitch":"index_tabSwitch_cpqXK"};